document.addEventListener("DOMContentLoaded", function () {
  initReadMoreContainers();
});
function initReadMoreContainers() {
  document.querySelectorAll('.read-more__container').forEach(container => {
    const content = container.querySelector('.read-more__content');
    const button = container.querySelector('.read-more__btn');
    
    if (!content || !button) return;
    
    const spanReadMore = button.querySelector('.read-more__text');
    const spanReadLess = button.querySelector('.read-less__text');
    
    if (!spanReadMore || !spanReadLess) return;
    
    const maxVisibleLines = parseInt(content.dataset.chunkLines, 10) || 10;
    
    const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
    
    const maxHeight = maxVisibleLines * lineHeight;
    
    const contentHeight = content.scrollHeight;
    
    let visibleMarginBottom = 0;
    let accumulatedHeight = 0;
    
    content.childNodes.forEach(child => {
      if (child.nodeType === 1) { 
        const childHeight = child.offsetHeight;
        const childMarginBottom = parseFloat(getComputedStyle(child).marginBottom) || 0;
        
        accumulatedHeight += childHeight;
        
        if (accumulatedHeight <= maxHeight) {
          visibleMarginBottom += childMarginBottom;
        }
      }
    });
    
    const adjustedMaxHeight = maxHeight + visibleMarginBottom;
    
    const totalLines = Math.ceil(contentHeight / lineHeight);
    
    if (totalLines > maxVisibleLines) {
      button.style.display = 'inline-block';
      
      button.addEventListener('click', function () {
        const isExpanded = content.classList.toggle('expanded');
        
        if (isExpanded) {
          content.style.maxHeight = `${contentHeight}px`;
          spanReadMore.style.display = 'none';
          spanReadLess.style.display = 'inline';
        } else {
          content.style.maxHeight = `${adjustedMaxHeight}px`;
          spanReadMore.style.display = 'inline';
          spanReadLess.style.display = 'none';
        }
      });
      
      content.style.maxHeight = `${adjustedMaxHeight}px`;
    } else {
      button.style.display = 'none';
    }
  });
}


function activeCustomer(shopifyClient) {
  if (document.querySelector('.container-form--active-customer-app-block')) {
    /*
      Form Shopify App: la ejecucion de estos formularios es un poco compleja debido a que no es la etiqueta form
      la que envia los datos, sino que se utiliza fetch para enviar los datos a una url especifica
      Esta url: https://forms.shopifyapps.com/api/v2/form_submission

      Es la que realmente envia los datos del formulario de la app por lo tanto se creo una funcion que 
      intercepta los fetch de la pagina para poder ejecutar la consulta GraphQL en el momento indicado

      la idea es que cuando se envie el fetch de la url indicada, se ejecute la funcion customerRecover
      del cliente de Shopify Storefront API para que envie el email de recuperacion de contraseña si fuese el caso

      ya el formulario de la app se encarga de enviar el email de activacion de cuenta si fuese el caso, 
      esto por medio de un flujo en la app Shopify Flow

      Importante: no solo la url es importante, tambien el metodo debe ser POST y el body debe ser un string JSON,
      debido a que existe otra consulta que se hace con la misma url y el body es un FormData, que no permite obtener
      el email

      Para mas informacion sobre la consulta GraphQL customerRecover ver el archivo wim-storefront.js
    */
    const originalFetch = window.fetch;
    window.fetch = function (...args) {

      return originalFetch.apply(this, args).then((response) => {
        const [url, options] = args;
        if (
          url === 'https://forms.shopifyapps.com/api/v2/form_submission' &&
          options.method === 'POST' &&
          typeof options.body === 'string'
        ) {
          try {
            // document.getElementById('recover-title').style.display = 'none';
            // document.getElementById('recover-subtitle').style.display = 'none';
            let body_json = JSON.parse(options.body);
            if (body_json && body_json?.email) {
              shopifyClient.customerRecover(body_json.email).then((res) => {
                console.log('Recovery email sent:', res);
                setTimeout(() => {
                  window.location.href = '/account/login';
                }, 20000);
              });
            }
          } catch (error) {
            console.error('Error occurred while sending recovery email:', error);
          }
        }
        return response;
      });
    };
  }
}

(function injectShopifyFormEmbedStyles() {
  const TARGET_SELECTOR = 'shopify-forms-embed';
  const CSS = `
    input {
      border: 1px solid var(--color-form-border);
      padding: 12px 17px;
      height: 48px;
      margin-bottom: 10px;
      color: var(--color-body);
      font-size: .8125rem;
      font-weight: 400;
      background: var(--bg-body);
      max-width: 100%;
      border-radius: var(--input-border-radius, 3px) !important;
      -webkit-appearance: none !important;
      appearance: none;
      height: fit-content;
      padding: 12px 17px;
    }
    button {
      display: inline-flex;
      cursor: pointer;
      padding: 6px 30px;
      align-items: center;
      justify-content: center;
      height: 46px;
      font-size: .8125rem;
      font-weight: var(--font-body-medium-weight, 500);
      letter-spacing: var(--button-letter-spacing);
      border: 1px solid var(--solid-button-background, var(--color-accent));
      background: var(--solid-button-background, var(--color-accent));
      color: var(--solid-button-label, #fff);
      border-radius: var(--button-border-radius, 3px);
      text-align: center;
      position: relative;
      z-index: 1;
      overflow: hidden;
      transition: border .25s cubic-bezier(.68,.01,.33,.97),color .25s cubic-bezier(.68,.01,.33,.97),background .25s cubic-bezier(.68,.01,.33,.97),transform .5s cubic-bezier(.19,1,.22,1);
      -webkit-appearance: none;
      appearance: none;
    }
    form > div input[type="date"]:focus + label, form > div input[type="date"]:not(:placeholder-shown) + label, form > div input[type="datetime"]:focus + label, form > div input[type="datetime"]:not(:placeholder-shown) + label, form > div input[type="email"]:focus + label, form > div input[type="email"]:not(:placeholder-shown) + label, form > div input[type="number"]:focus + label, form > div input[type="number"]:not(:placeholder-shown) + label, form > div input[type="password"]:focus + label, form > div input[type="password"]:not(:placeholder-shown) + label, form > div input[type="search"]:focus + label, form > div input[type="search"]:not(:placeholder-shown) + label, form > div input[type="tel"]:focus + label, form > div input[type="tel"]:not(:placeholder-shown) + label, form > div input[type="text"]:focus + label, form > div input[type="text"]:not(:placeholder-shown) + label, form > div input[type="time"]:focus + label, form > div input[type="time"]:not(:placeholder-shown) + label, form > div input[type="url"]:focus + label, form > div input[type="url"]:not(:placeholder-shown) + label, form > div select:focus + label, form > div select:not(:placeholder-shown) + label, form > div textarea:focus + label, form > div textarea:not(:placeholder-shown) + label {
      top: 0 !important;
      background-color: white !important;
      padding: 1px 6px !important;
      width: fit-content !important;
    }
  `;
  function tryInject(el) {
    try {
      if (!el || el.dataset.wimInjected) return;
      const sr = el.shadowRoot;
      if (!sr) return;
      const style = document.createElement('style');
      style.setAttribute('data-wim-inject', 'true');
      style.textContent = CSS;
      sr.appendChild(style);
      sr.querySelector('button[type="submit"]').classList.add('btn', 'btn--primary');
      sr.querySelector('button[type="submit"]').innerHTML = `<span class="btn__text">${sr.querySelector('button[type="submit"]').textContent}</span>`;
      el.dataset.wimInjected = '1';

      const shopifyClient = new ShopifyStorefrontClient();
      activeCustomer(shopifyClient);
    } catch (e) {
      console.error('[wim] error injecting styles into shadowRoot', e);
    }
  }

  // Inyectar en los elementos embebidos existentes
  document.querySelectorAll(TARGET_SELECTOR).forEach(tryInject);

  // Observar el DOM en busca de nuevos elementos embebidos
  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches && node.matches(TARGET_SELECTOR)) tryInject(node);
        const descendants = node.querySelectorAll ? node.querySelectorAll(TARGET_SELECTOR) : [];
        descendants.forEach(tryInject);
      }
    }
  });
  observer.observe(document.documentElement || document.body, { childList: true, subtree: true });

  // Intento de reintento de seguridad para shadowRoots inicializados tarde
  let retries = 0;
  const maxRetries = 10;
  const retryInterval = setInterval(() => {
    document.querySelectorAll(TARGET_SELECTOR).forEach(tryInject);
    retries++;
    if (retries >= maxRetries) clearInterval(retryInterval);
  }, 500);
})();
